import MP4Box from 'mp4box';

export default {
  methods: {
    getVideoTracks(info) {
      // video tracks have width and height, use random value of 480 pixels here
      return info.tracks.filter(o => _.get(o, 'trackWidth') >= 320 && _.get(o, 'trackHeight') >= 240);
    },
    getVideoInfoByChunk(file) {
      return new Promise((resolve, reject) => {
        const chunkSize = 100 * 1024 * 1024; // 100 MB chunks
        let offset = 0;

        const fileReader = new FileReader();
        const mp4box = MP4Box.createFile();

        mp4box.onError = (e) => {
          reject(new Error(`MP4 parsing error: ${e.message}`));
        };

        mp4box.onReady = (info) => {
          console.log('=========== onReady ', info);
          const videoTracks = this.getVideoTracks(info);
          if (videoTracks) {
            resolve(info);
          } else {
            reject(new Error('No video track found in the file.'));
          }
        };

        // Read and append chunks to MP4Box
        const readNextChunk = () => {
          // console.log('====== read next chunk');
          const chunk = file.slice(offset, offset + chunkSize);
          // console.log(chunk);
          fileReader.readAsArrayBuffer(chunk);
        };

        fileReader.onload = (e) => {
          const arrayBuffer = e.target.result;
          arrayBuffer.fileStart = offset;
          offset += chunkSize;
          console.log(offset / 1024 / 1024, 'Mb');

          // Append the buffer to MP4Box
          try {
            mp4box.appendBuffer(arrayBuffer);
          } catch (err) {
            console.error(err);
            reject(new Error(err));
          }

          // If there’s more data, read the next chunk
          if (offset < file.size) {
            readNextChunk();
          } else {
            // Finalize the parsing when all data is read
            mp4box.flush();
          }
        };

        fileReader.onerror = () => {
          reject(new Error('Error reading file.'));
        };

        // Start reading the first chunk
        readNextChunk();
      });
    },
  },
};
